export default __webpack_public_path__ + "static/kb_3_4-1d85cce80264fb3b8e3f0155630a6d7f.jpeg";